import { Component } from "@angular/core";
import { NavController, NavParams, ModalController } from "ionic-angular";
import { APIServiceProvider } from "./../../common/services/api.service";

import { ProductModal } from "./productmodal";
import { ProductServiceProvider } from "./product.service";

@Component({
  selector: "page-products",
  templateUrl: "products.html"
})
export class ProductsPage {
  public products: any = [];
  public selectedLanguage: any = {};
  public singleProductDetails: any = {
    sku: "",
    price: 0
  };



  show_note: any = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public productService: ProductServiceProvider,
    public modalCtrl: ModalController,
    public apiService: APIServiceProvider
    ) {}

  ionViewDidLoad() {
  }

  selectProduct() {
    this.navCtrl.push(ProductModal, { type: "products" });
  }

  updatePrice(ev) {
    this.productService.productObj.total =
    parseFloat(this.productService.productObj.product_selling_price) *
    parseFloat(this.productService.productObj.quantity);

    this.productService.productObj.total = parseFloat(
      this.productService.productObj.total
      ).toFixed(2);
  }

  productDetails(product) {
    this.singleProductDetails = {
      sku: product.product_weight,
      price: product.product_selling_price
    };
  }

  remove() {
    this.show_note = false;
  }


  
  
}



// WEBPACK FOOTER //
// ./src/pages/products/products.ts